/**
 * @flow
 * Created by neo on 18.02.17.
 */

import { observable, action, computed } from 'mobx';
import Aircraft from '../Aircraft';
import Availability from './Availability';
import BackendFactory from '../../Services/BackendFactory';
import FlightRoute from '../Flight/FlightRoute';
import Payment from '../Payment';
import Settings from '../Settings';

export class FlightOfferAircraft {
  @observable id: number;
  @observable aircraft_model: Aircraft = new Aircraft();
  @observable passengers_capacity: number;
  @observable passengers_min: number;
  @observable price_passenger: number;
  @observable price_exclusive: number;
  @observable currency_code: string;
  @observable flight_offer: FlightOffer;

  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.aircraft_model = new Aircraft(json.aircraft_model || {});
      this.passengers_capacity = json.passengers_capacity;
      this.passengers_min = json.passengers_min;
      this.price_passenger = parseFloat(json.price_passenger);
      this.price_exclusive = parseFloat(json.price_exclusive);
      this.currency_code = json.currency_code || Settings.settings.get('currency');
      this.flight_offer = new FlightOffer(json.flight_offer);

      this.currency = json.currency
    }
  }
};

// TODO: delete?
export class AirportCode {
  @observable code: string;
  @observable type: 'IATA' | 'ICAO';
  constructor(json?: any) {
    if(json) {
      this.code = json.code;
      this.type = json.type;
    }
  }
}

export default class FlightOffer {
  @observable id: string;
  @observable title: string;
  @observable description: string;
  @observable aircraft_offers: Array<FlightOfferAircraft> = [];
  @observable route: FlightRoute = new FlightRoute();
  @observable flight_type: Object = {};
  @observable time_pickup: number;
  @observable time_flight: number;
  @observable time_before: number;
  @observable time_after: number;
  @observable time_dropoff: number;
  @observable time_return: number;
  @observable is_transfer: number;
  @observable availability: Array<Availability> = [];
  @observable location: Object = {};
  @observable dropoff_location: Object = {};
  @observable files: Array<any> = [];
  @observable payment_types: Array<Payment> = []
  @observable _isNew = true;

  constructor(json: any) {
    if(json) {
      this.id = json.id;
      this.title = json.title || '';
      this.description = json.description || '';
      this.route = new FlightRoute(json.route || {});
      this.flight_type = json.flight_type;
      this.time_flight = json.time_flight;
      this.time_before = json.time_before;
      this.time_after = json.time_after;
      this.time_pickup = json.time_pickup;
      this.time_dropoff = json.time_dropoff;
      this.time_return = json.time_return;
      this.is_transfer = json.is_transfer;
      this.availability = (json.availability || []).map(a => new Availability(a));
      this.location = (json.location || {});
      this.dropoff_location = (json.dropoff_location || {});
      this.aircraft_offers = (json.aircraft_offers || []).map(a => new FlightOfferAircraft(a));
      this.files = json.files || [];
      this.payment_types = (json.payment_types || [{ name: 'ON_SITE' }, { name: 'ONLINE'}]).map(a => new Payment(a));
    }
  }

  static async load(page?: number = 0, lang: string, location?: array = []) {
    if (!page || 0 >= page) {
      page = 1;
    }

    const backend = await BackendFactory();
    const res = await backend.get('/offer', { page, lang, location });
    if (res.ok) {
      res.data.content = res.data.data.map(f => new FlightOffer(f));
      return res.data;
    }
  }

  static async loadTransfers() {
    const backend = await BackendFactory();
    const res = await backend.get('/transfer');

    if (res.ok) {
      return {
        data: res.data,
        content: res.data.map(f => new FlightOffer(f))
      };
    }
  }

  static async get(id: string, exclusive: boolean, lang: string): Promise<FlightOffer> {
    const backend = await BackendFactory();
    const res = await backend.get(`/offer/${id}`, { lang, exclusive });
    if (res.ok) {
      return new FlightOffer(res.data);
    }
    return null;
  }

  @computed get minSeatPrice(): number {
    const prices = this.aircraft_offers.map(a => a.price_passenger || a.price_exclusive);
    return prices.length > 0 ? Math.min(...prices) : null;
  }

  @computed get minSeatPriceCurrency(): string {
    if (this.aircraft_offers.length == 0) {
      return Settings.settings.get('currency');
    }

    let currency = this.aircraft_offers[0].currency_code;
    let minPrice = this.aircraft_offers[0].price_passenger;
    this.aircraft_offers.map(a => {
      if (a.price_passenger < minPrice) {
        currency = a.currency_code;
        minPrice = a.price_passenger;
      }
    });

    return currency;
  }
  
  @computed get durationInMinutes(): number {
    return this.time_flight;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/FlightOffer/index.js